import React from 'react'
import PropTypes from 'prop-types'
import styles from './footerLinks.module.scss'

const FooterLinks = ({ links = [] }) => {
  return (
    <div className={styles.footerLinks}>
      {links.map((link, index) => (
        <a href={link.href} key={index}>
          {link.tag}
        </a>
      ))}
    </div>
  )
}

FooterLinks.propTypes = {
  links: PropTypes.array,
}

export { FooterLinks }
